import moment from "moment";

// รูปแบบค่าของ <input type="datetime-local">
const INPUT_DATE_TIME = "YYYY-MM-DDTHH:mm";

// เลขตู้มาตรฐาน ISO 6346 — ใช้จัดรูปและเตือน check digit เท่านั้น ไม่บังคับ (server รับเลขตู้รูปแบบอื่นได้)
const CONTAINER_NO_PATTERN = /^[A-Z]{4}\d{7}$/;
export const CONTAINER_NO_MAX_LENGTH = 40;

let lastRowKey = 0;
const nextRowKey = () => {
  lastRowKey += 1;
  return lastRowKey;
};

export function toInputDateTime(value) {
  return value ? moment(value).format(INPUT_DATE_TIME) : "";
}

// เหมือน normalizeContainerNo ฝั่ง API: ตัดช่องว่าง/ขีดเฉพาะเมื่อได้เลขตู้มาตรฐาน ; รูปแบบอื่นเก็บตามที่พิมพ์ (ตัวพิมพ์ใหญ่)
export function normalizeContainerNo(value) {
  const text = (value ?? "").trim().toUpperCase().split(/\s+/).join(" ");
  const compact = text.split(/[\s-]+/).join("");
  return CONTAINER_NO_PATTERN.test(compact) ? compact : text;
}

// ตัวเลขตรวจสอบหลักสุดท้ายของเลขตู้ตาม ISO 6346 (A=10 … Z=38 โดยข้ามค่าที่หาร 11 ลงตัว)
function letterValue(letter) {
  const value = letter.codePointAt(0) - 55;
  return value + Math.floor((value - 1) / 10);
}

function hasValidCheckDigit(containerNo) {
  let sum = 0;
  for (let index = 0; index < 10; index += 1) {
    const char = containerNo[index];
    const value = index < 4 ? letterValue(char) : Number(char);
    sum += value * 2 ** index;
  }
  return (sum % 11) % 10 === Number(containerNo[10]);
}

// เตือนเฉพาะเลขตู้มาตรฐานที่ check digit ไม่ตรง (ยังบันทึกได้ — ข้อมูลเดิมมีตู้แบบนี้ ~0.1%) ; รูปแบบอื่นไม่เตือน
export function containerNoWarning(value) {
  const containerNo = normalizeContainerNo(value);
  if (!CONTAINER_NO_PATTERN.test(containerNo) || hasValidCheckDigit(containerNo)) return null;
  return "check digit ไม่ตรง — ตรวจเลขตู้อีกครั้ง";
}

export function emptyTripRow(leg) {
  return {
    key: nextRowKey(),
    TruckNo: "",
    ContainerNo: "",
    ETD: toInputDateTime(leg?.ETD),
    ETA: toInputDateTime(leg?.ETA),
  };
}

export function toTripRow(trip) {
  return {
    key: nextRowKey(),
    TruckNo: trip.TruckNo ?? "",
    ContainerNo: trip.ContainerNo ?? "",
    ETD: toInputDateTime(trip.ETD),
    ETA: toInputDateTime(trip.ETA),
  };
}

// แถวที่ยังไม่กรอกเลขรถ/เลขตู้ = แถวว่าง (ETD/ETA เติมให้อัตโนมัติ จึงไม่นับ)
export function isBlankRow(row) {
  return [row.TruckNo, row.ContainerNo].every((value) => value.trim() === "");
}

// ส่งแถวว่างไปเป็นแถวว่างจริง (server ข้ามให้) เพื่อให้เลขแถวใน error ตรงกับคอลัมน์ No ของตาราง
export function toTripPayload(row) {
  if (isBlankRow(row)) {
    return { TruckNo: "", ContainerNo: "", ETD: null, ETA: null };
  }
  return {
    TruckNo: row.TruckNo,
    ContainerNo: row.ContainerNo,
    ETD: row.ETD || null,
    ETA: row.ETA || null,
  };
}

export function errorText(err, fallback) {
  if (err?.response?.status === 413) return "ไฟล์ใหญ่เกิน 5 MB";
  return err?.response?.data?.message || fallback;
}
